__turbopack_context__.v({
  "all": "site-search-module__PVEeQG__all",
  "box": "site-search-module__PVEeQG__box",
  "corrected": "site-search-module__PVEeQG__corrected",
  "expanded": "site-search-module__PVEeQG__expanded",
  "field": "site-search-module__PVEeQG__field",
  "groupIcon": "site-search-module__PVEeQG__groupIcon",
  "groupTitle": "site-search-module__PVEeQG__groupTitle",
  "groupTotal": "site-search-module__PVEeQG__groupTotal",
  "hotkey": "site-search-module__PVEeQG__hotkey",
  "message": "site-search-module__PVEeQG__message",
  "option": "site-search-module__PVEeQG__option",
  "results": "site-search-module__PVEeQG__results",
  "siteSearch": "site-search-module__PVEeQG__siteSearch",
  "toggle": "site-search-module__PVEeQG__toggle",
});
